import React from 'react';
import { CapaQuotationChatMessageRfq } from '@generated/graphql';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import QuotationProgressPresenter from './QuotationProgressPresenter';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all'
    }
  };
});

interface Props {
  message: CapaQuotationChatMessageRfq;
}

const QuotationAdjustRequestBubble: React.FC<Props> = ({ message }) => {
  const classes = useStyles();
  const content = message.rfq?.adjustRequest ?? '';

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          견적서
        </CustomizedTypography>
      </div>
      <QuotationProgressPresenter activeStep={1} />
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            견적서 수정 요청 발송
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            아래와 같은 내용으로 파트너에게 견적서 수정 요청을 발송했습니다.
            <br />
            <br />
            {content}
          </CustomizedTypography>
        </div>
      </div>
    </Box>
  );
};

export default QuotationAdjustRequestBubble;
